const { same } = require('../utils');

exports.computeHasTotalRowFromTables = tables => same(tables, 'hasTotalRow', false);
